import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFadeTransition,{attrs:{"mode":"out-in"}},[_c(VBtn,{key:_vm.isDark,staticClass:"me-3 no-bg",attrs:{"icon":"","aria-label":_vm.$t('common.change_theme')},on:{"click":function($event){_vm.isDark = !_vm.isDark}}},[_c(VIcon,[_vm._v(" "+_vm._s(_vm.isDark ? _vm.icons.mdiWeatherSunny : _vm.icons.mdiWeatherNight)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }